



import { useState } from 'react';
import '../Assets/Css/civil.css';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaRoad, FaTools, FaRegCheckCircle, FaCogs } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import aboutsecurity from '../Assets/Image/aboutcivil.avif';


import ctasecureimg from '../Assets/Image/ctacivil.avif';
import { Helmet } from 'react-helmet';

import commercialCivilImg from '../Assets/Image/Commercial Industrial Civil1.avif';
import pebCivilImg from '../Assets/Image/PEB1.jpg';
import epoxyImg from '../Assets/Image/Epoxy Flooring Services1.avif';
import roadMarkingImg from '../Assets/Image/Thermoplastic Road Marking Services1.jpg';

import civil1 from '../Assets/Image/Commercial Industrial Civil2.avif';
import civil2 from '../Assets/Image/Commercial Industrial Civil4.avif';
import civil3 from '../Assets/Image/Commercial Industrial Civil3.avif';

import peb1 from '../Assets/Image/PEB2.avif';
import peb2 from '../Assets/Image/PEB3.avif';
import peb3 from '../Assets/Image/PEB4.avif';

import epoxy1 from '../Assets/Image/Epoxy Flooring Services2.avif';
import epoxy2 from '../Assets/Image/Epoxy Flooring Services3.avif';
import epoxy3 from '../Assets/Image/Epoxy Flooring Services4.jpg';

import road1 from '../Assets/Image/Thermoplastic Road Marking Services2.jpg';
import road2 from '../Assets/Image/Thermoplastic Road Marking Services3.jpg'
import road3 from '../Assets/Image/Thermoplastic Road Marking Services4.avif';


export default function CivilConstructionServices() {

  const [selectedService, setSelectedService] = useState(null);



  const handleExplore = (service) => {
    setSelectedService(service);
    setTimeout(() => {
      const el = document.getElementById('explore-section');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };


  const testimonials = [
    {
      message: "The Civil & Construction Services were precise and professionally done. Our parking lot looks organized and safe.",
      author: "Facility Manager",
    },
    {
      message: "Excellent quality road markings on our industrial site. Clear, durable, and compliant.",
      author: "Project Engineer",
    },
    {
      message: "Quick and efficient work on pedestrian crossings and directional arrows. Highly visible and long-lasting.",
      author: "Municipal Supervisor",
    },
  ];





  const civilServices = [
    {
      id: 1,
      title: "Commercial & Industrial Civil Work",
      description:
        "We offer expert civil construction services for commercial buildings and industrial infrastructure. Our work covers everything from foundations and structural framing to concrete flooring, block masonry, and site development.",
      howItWorks:
        "Our team coordinates with architects and structural consultants to execute construction plans on time. We follow IS codes, prioritize safety, and use modern tools for precision and quality control.",
      benefits: [
        "Durable and code-compliant structures",
        "On-time project delivery",
        "Experienced project management",
      ],
      usedIn: ["Factories", "Office buildings", "Warehouses", "Retail spaces"],
      image: commercialCivilImg,
      relatedImages: [civil1, civil2, civil3],
    },
    {
      id: 2,
      title: "Pre-Engineering Buildings and Civil Work Services",
      description:
        "We design and construct pre-engineered buildings (PEBs) which are cost-effective, quicker to erect, and structurally robust. From groundwork to structural steel assembly, our team manages every aspect.",
      howItWorks:
        "PEBs are fabricated off-site and assembled on-site. We integrate civil foundations with structural steel erection, cladding, and finishing – ensuring a seamless build process.",
      benefits: [
        "Faster construction timelines",
        "Lightweight yet strong structures",
        "Reduced labor and material waste",
      ],
      usedIn: ["Industrial sheds", "Warehouses", "Commercial outlets", "Sports halls"],
      image: pebCivilImg,
      relatedImages: [peb1, peb2, peb3],
    },
    {
      id: 3,
      title: "Epoxy Flooring Service Solutions",
      description:
        "We provide epoxy flooring solutions that are durable, chemical-resistant, and easy to clean. Ideal for industrial and commercial settings requiring hygiene and strength.",
      howItWorks:
        "Our team cleans and levels the concrete base, applies primer and base coat, then finishes with colored or anti-skid epoxy topcoat – ensuring a glossy and strong surface.",
      benefits: [
        "Chemical and abrasion resistance",
        "Improved safety and aesthetics",
        "Easy to maintain and long-lasting",
      ],
      usedIn: ["Pharmaceutical plants", "Food processing units", "Garages", "Showrooms"],
      image: epoxyImg,
      relatedImages: [epoxy1, epoxy2, epoxy3],
    },
    {
      id: 4,
      title: "Thermoplastic Road Marking Services",
      description:
        "We deliver road marking services using thermoplastic paint for durability, reflectivity, and safety. Ideal for highways, campuses, and industrial roads.",
      howItWorks:
        "We clean the road surface, preheat the material, and apply precise markings with line-laying equipment. The markings dry quickly and resist wear, even under heavy traffic.",
      benefits: [
        "High visibility in all weather",
        "Quick drying and traffic-ready",
        "Long-lasting and low maintenance",
      ],
      usedIn: [
        "Roadways and highways",
        "Industrial campuses",
        "Parking areas",
        "Residential layouts",
      ],
      image: roadMarkingImg,
      relatedImages: [road1, road2, road3],
    },
  ];


  return (
    <div className="mainnav min-vh-100">
      <Helmet>
        {/* Basic SEO */}
        <title>Civil & Construction Services | Industrial & Commercial Projects - Pradh</title>
        <meta
          name="description"
          content="Get high-quality civil and construction services from Pradh. From industrial sheds and epoxy flooring to thermoplastic road marking and PEBs, we deliver strength, safety, and speed."
        />
        <meta
          name="keywords"
          content="Civil Construction India, Industrial Civil Work, Epoxy Flooring, Thermoplastic Road Marking, Pre-Engineered Buildings, PEB India, Construction Company India, Pradh Management Solutions"
        />
        <meta name="author" content="Pradh Management Solutions" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Civil & Construction Services | Pradh Management Solutions" />
        <meta
          property="og:description"
          content="Specialized civil and construction solutions for industrial, commercial, and infrastructure projects including epoxy flooring, industrial sheds, and PEB structures."
        />
        <meta property="og:url" content="https://pradh.com/civil-construction" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://pradh.com/images/civil-construction-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Civil & Construction Services | Pradh Management Solutions" />
        <meta
          name="twitter:description"
          content="From foundation to finish, Pradh delivers expert civil and construction services including epoxy flooring, road markings, and PEB structures for all sectors."
        />
        <meta name="twitter:image" content="https://pradh.com/images/civil-construction-banner.jpg" />

        {/* Canonical */}
        <link rel="canonical" href="https://pradh.com/civil-construction" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-sectionmark">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in" >Civil & Construction <br /> Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">Quality construction tailored to your needs.</p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100"> Get in Touch </a>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-us py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col md={5} className="text-center mb-4 mb-md-0">
              <img
                src={aboutsecurity}
                alt="Civil & Construction Services"
                className="img-fluid aboutsecimg rounded shadow"
                data-aos="zoom-in"
                data-aos-delay="100"
              />
            </Col>
            <Col md={7}>
              <h2 className="page-title " data-aos="fade-up">
                Overview
              </h2>
              <p data-aos="zoom-in" data-aos-delay="150">
                At <strong style={{ color: '#04A1D3' }}>Pradh Management Solutions</strong>, we deliver comprehensive Civil & Construction
                services tailored to industrial, commercial, and infrastructure projects. Our expertise spans structural frameworks, flooring,
                industrial sheds, epoxy installations, and pre-engineered buildings.
              </p>
              <p data-aos="zoom-in" data-aos-delay="200">
                Whether you're developing a large-scale facility or retrofitting an existing space, we ensure timely execution, quality materials,
                and adherence to safety codes. From foundation to finish, our solutions guarantee long-term durability and operational efficiency.
              </p>
            </Col>
          </Row>
        </Container>
      </section>


      <section className="services-content py-5 bg-light">
        <Container>
          <h2 className="page-title text-center mb-4" data-aos="fade-up">
            Our Civil & Construction Services
          </h2>
          <Row>
            {civilServices.map((service, index) => (
              <Col md={3} sm={6} xs={12} className="mb-4" key={index}>
                <Card
                  className="civilservicecard h-100 border-0 hover-shadow"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                >
                  <Card.Img
                    variant="top"
                    src={service.image}
                    alt={service.title}
                    className="civilservice-image"
                  />
                  <Card.Body className="text-center">
                    <h6 style={{ color: "#C52316" }}>{service.title}</h6>
                    <Button
                      variant="outline-primary"
                      className="mt-3 explore-btn"
                      onClick={() => handleExplore(service)}
                    >
                      Explore Service
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {selectedService && (
            <Row className="mt-5 scroll-offset" id="explore-section">
              <Col md={10} className='mx-auto'>
                <div className="p-4 rounded shadow-lg explore-section bg-white">
                  <h3 className="text-center mb-3" style={{ color: "#C52316" }}>
                    {selectedService.title}
                  </h3>
                  <img
                    src={selectedService.image}
                    alt={selectedService.title}
                    className="img-fluid rounded mb-4 explore-main-img"
                  />
                  <p>
                    <strong>Description:</strong> {selectedService.description}
                  </p>
                  <p>
                    {selectedService.howItWorks}
                  </p>
                  <Row>
                    <Col md={6}>
                      <p>
                        <strong>Benefits:</strong>
                      </p>
                      <ul>
                        {selectedService.benefits.map((b, i) => (
                          <li key={i}>{b}</li>
                        ))}
                      </ul>
                    </Col>
                    <Col md={6}>
                      <p>
                        <strong>Application Areas:</strong>
                      </p>
                      <ul>
                        {selectedService.usedIn.map((u, i) => (
                          <li key={i}>{u}</li>
                        ))}
                      </ul>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    {selectedService.relatedImages.map((img, i) => (
                      <Col md={4} sm={6} key={i}>
                        <img
                          src={img}
                          alt={`Related ${i + 1}`}
                          className="img-fluid rounded explore-thumb"
                        />
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </section>


      {/* Contact CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="100">
              <h2>Ready to Build with Confidence? </h2>
              <p className="lead">
                Partner with <strong>Pradh Management Solutions</strong> for trusted, high-quality civil and construction services that deliver strength, speed, and satisfaction. Let’s bring your vision to life — on time and on budget.
              </p>
              <a href="/contact" className="btn-get"> Get in Touch </a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img
                  src={ctasecureimg}
                  alt="Professional service team at work"
                  className="img-fluid  rounded shadow"
                  data-aos="zoom-in" data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up"> What Our Clients Say </h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="200">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>
                        “{testimonial.message}”
                      </p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
